import Banner from "../components/Banner/Banner";
import Footer from "../components/Footer/Footer";
import Navigation from "../components/Navigation/Navigation";
import CreateNewPostJob from "../components/PostJob/CreateNewPostJob";
import Spinner from "../components/Spinner/Spinner";

function CreateNew() {
  return (
    <div className="container-xxl bg-white p-0">
      <Spinner />
      <Navigation />
      <Banner pageName="Create New Job" />
      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
        <CreateNewPostJob />
      </div>
      <Footer />
    </div>
  );
}

export default CreateNew;
